<template>
  <section class="hub-multimediale-section">
    <div class="hub-multimediale-section__top">
      <NavCard
        v-for="page of pages"
        class="hub-multimediale-section__top__card"
        :key="page"
        :page="page"
      />
    </div>

    <div class="hub-multimediale-section__bottom">
      <h2 class="hub-multimediale-section__bottom__title">
        {{ title }}
      </h2>

      <p class="hub-multimediale-section__bottom__text">
        {{ introText }}
      </p>

      <ButtonPrimary :label="cta" internalUrlParam="download-multimedia" black />
    </div>
  </section>
</template>

<script setup>
import ButtonPrimary from "../general/ButtonPrimary.vue";
import NavCard from "../general/NavCard.vue";

import { computed } from "vue";
import { useI18n } from "vue-i18n";

defineProps({
  title: String,
  introText: String,
  cta: String,
});

const { tm } = useI18n();

const pages = computed(() =>
  Object.keys(tm("navigation")).filter(
    (page) => !["home", "download-multimedia"].includes(page)
  )
);
</script>

<style lang="scss" scoped>
.hub-multimediale-section {
  --card-overflow: 10rem;

  &__top {
    display: flex;
    justify-content: space-between;
    padding: 0 var(--page-padding-h);
    margin-top: calc(var(--card-overflow) * -1);

    .mobile &,
    .tablet & {
      flex-direction: column;
    }

    &__card {
      .desktop &,
      .large & {
        width: 30%;
      }

      transform: translateY(var(--card-overflow));
    }
  }

  &__bottom {
    background-image: var(--gradient-giallo-2);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: calc(7vh + var(--card-overflow)) var(--page-padding-h) 7vh;
    text-align: center;

    &__title {
      @include title-m;

      margin-bottom: toRem(6);
    }

    &__text {
      @include p-s;

      margin-bottom: 1.25rem;
      max-width: toRem(500);
    }
  }
}
</style>
